<template>
  <section slot="main" class="interact-letter-form-index-container">
    <base-header
      v-bind="letterTypeHeaders"
      @handleNewFrom="handleHeaderNewFrom"
      @handleDelete="handleHeaderDelete"
    />

    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="list.params"
      @handleSearch="handleSearchs"
    ></search-header>
    <base-table
      v-bind="list"
      v-on:handleDelete="handleTableDelete"
      v-on:handleSelectionChange="handleLetterSelect"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
    <template #name="scope">
      <div class="jee-color title-box">
        <!-- <div @click="toLinkAddress(scope.scope.row)" v-if="scope.scope.row.viewStatus===1||scope.scope.row.viewStatus===2">
          <jee-icon iconClass="lianjiexingyinyong"></jee-icon>
        </div> -->
        <p class="smart-title" @click="editForm(scope.scope.row)">{{scope.scope.row.name}}</p>
      </div>
    </template>
    <template #form="scope">
      <div class="jee-hover-color" style="cursor: pointer;" @click="alterForm(scope.scope.row)" v-if="scope.scope.row.form&&scope.scope.row.form.title">
         {{scope.scope.row.form.title}}
         <i class="el-icon-caret-bottom"></i>
      </div>
    </template>
    <template #letterBox="scope">
      <div class="jee-hover-color" style="cursor: pointer;" @click="alterLetterBox(scope.scope.row)" v-if="scope.scope.row.letterBox&&scope.scope.row.letterBox.name">
         {{scope.scope.row.letterBox.name}}
         <i class="el-icon-caret-bottom"></i>
      </div>
    </template>
    </base-table>
    <form-dialog
      ref="addForm"
      v-bind="formEdit"
      :rules="rules"
      v-on:handleConfirm="handleConfirmForm"
      class="smart-add-from"
    ></form-dialog>
    <form-dialog
      ref="alterLetterBoxForm"
      v-bind="alterLetterBoxForm"
      :rules="alterLetterBoxRules"
      v-on:handleConfirm="handleConfirmAlterLetterBox"
    ></form-dialog>
    <form-dialog
      ref="alterLetterForm"
      v-bind="alterLetterForm"
      :rules="alterLetterFormRules"
      v-on:handleConfirm="handleConfirmAlterLetterForm"
    ></form-dialog>
  </section>
</template>

<script>
import formDialog from '@/components/mixins/formDialog'
import baseHeader from '@/components/mixins/baseHeader'
import searchHeader from '@/components/mixins/searchHeader'
import baseTable from '@/components/mixins/baseTable'
const columns = [
  // {
  //   prop: 'id',
  //   label: 'ID',
  //   minWidth: '80px',
  //   fixed: 'left',
  // },
  {
    prop: 'name',
    label: '信件名称',
    minWidth: '165px',
    fixed: 'left',
    scopeType: 'slot'
  },
  {
    prop: 'form',
    label: '适用表单',
    minWidth: '145px',
    scopeType: 'slot'
  },
  {
    prop: 'letterBox',
    label: '接收信箱',
    minWidth: '145px',
    scopeType: 'slot'
  },
  {
    prop: 'createUser',
    label: '创建人',
    minWidth: '100px'
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: '180px'
  }
]
export default {
  name: 'interactLetterTypeIndex',
  mixins: [formDialog, baseHeader, searchHeader, baseTable],
  components: {},
  data () {
    return {
      formEdit: {
        loading: false,
        title: '新建',
        form: {
          name: '',
          formId: '',
          boxId: ''
        },
        formItems: [
          {
            prop: 'name',
            label: '类型名称',
            maxlength: 15
          },
          {
            prop: 'formId',
            label: '适用表单',
            type: 'select',
            options: []
          },
          {
            prop: 'boxId',
            label: '接收信箱',
            type: 'select',
            options: []
          }
        ],
        buttons: [
          {
            text: '保存并编辑字段',
            type: 'Submit',
            href: '/system/organize/permission'
          },
          {
            text: '保存',
            type: 'Submit'
          }
        ]
      },
      alterLetterForm: {
        loading: false,
        title: '修改适用表单',
        form: {
          formId: '',
          id: ''
        },
        formItems: [
          {
            type: 'select',
            prop: 'formId',
            label: '适用表单',
            options: []
          }
        ],
        buttons: [
          {
            text: '确定',
            type: 'Submit'
          }
        ]
      },
      alterLetterFormRules: {
        formId: [this.$rules.required()]
      },
      alterLetterBoxForm: {
        loading: false,
        title: '修改接收信箱',
        form: {
          boxId: '',
          id: ''
        },
        formItems: [
          {
            type: 'select',
            prop: 'boxId',
            label: '接收信箱',
            options: []
          }
        ],
        buttons: [
          {
            text: '确定',
            type: 'Submit'
          }
        ]
      },
      alterLetterBoxRules: {
        boxId: [this.$rules.required()]
      },
      letterTypeHeaders: {
        showAlertIcon: false,
        buttons: [
          {
            type: 'NewFrom',
            text: '新建',
            icon: 'xinjian',
            disabled: !this._checkPermission('/letterType', 'POST')
          },
          {
            type: 'Delete',
            text: '删除',
            icon: 'delete',
            disabled: !this._checkPermission('/letterType', 'DELETE')
          }
        ]
      },
      searchHeader: {
        searchItems: [
          {
            type: 'searchInput',
            value: 'name',
            placeholder: '请输入类型名称',
            style: {
              width: '330px'
            }
          }
        ]
      },
      list: {
        params: {
          formId: '',
          boxId: '',
          name: ''
        },
        columns,
        api: 'fetchLetterTypePage',
        handleColumn: [
          {
            type: 'Delete',
            name: '删除',
            icon: 'delete',
            disabled: !this._checkPermission('/letterType', 'DELETE')
          },
        ],
        handleColumnProp: {
          label: '操作',
          width: '100',
          fixed: 'right'
        }
      },
    }
  },
  computed: {
    rules () {
      return {
        name: [
          this.$rules.required(),
          {
            validator: (rule, value, callback) => {
              if (value) {
                var params = {
                  name: value,
                  id: this.formEdit.form.id || ''
                }
                this.$request.fetchLetterTypeUnique(params).then(res => {
                  if (res.code === 200) {
                    if (res.data) {
                      callback()
                    } else {
                      callback(new Error('信件类型名称不能重复'))
                    }
                  } else {
                    callback()
                  }
                })
              }
            },
            trigger: 'blur'
          }
        ]
      }
    },
  },
  methods: {
    // 表格多选操作
    handleLetterSelect (data) {
      var ids = data.map(v => v[this.list.rowKey || 'id'])
      this.list.selectedKeys = ids
    },
    // 新建表单
    handleHeaderNewFrom () {
      this.formEdit.title = '新建'
      this.formEdit.form = {
        name: '',
        // description: ''
      }
      this.$refs.addForm.showDialog()
    },
    // 确认新表单
    handleConfirmForm (data, btn) {
      console.log(data)
      this.formEdit.loading = true
      let formId = ''
      let boxId = ''
      let params = {
        formId: formId,
        boxId: boxId,
        ...data
      }
      if (data.id) {
        console.log('这里')
        this.$request.fetchLetterTypePut(params).then(res => {
          if (res.code === 200) {
            if (btn.href) {
              this.fetchTableApi()
              this.$routerLink('/interact/letter/type/detail', 'link', { id: res.data, state: 0 })
            } else {
              this.fetchTableApi()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
            }
          }
          this.formEdit.loading = false
        }).catch(() => {
          this.formEdit.loading = false
        })
      } else {
        console.log('再这里')
        this.$request.fetchLetterTypeAdd(params).then(res => {
          console.log(res.data)
          if (res.code === 200) {
            if (btn.href) {
              this.fetchTableApi()
              this.$routerLink('/interact/letter/type/detail', 'link', { id: res.data, state: 0 })
            } else {
              this.fetchTableApi()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
            }
          }
          this.formEdit.loading = false
        }).catch(() => {
          this.formEdit.loading = false
        })
      }
    },
    // 编辑表单
    editForm (data) {
      this.formEdit.title = '编辑'
      this.formEdit.form = Object.assign(this.formEdit.form, data)
      this.$refs.addForm.showDialog()
    },
    // 修改表单分组
    alterForm (row) {
      console.log(row)
      this.alterLetterForm.form.id = row.id
      this.alterLetterForm.form.formId = row.form.id
      this.$refs.alterLetterForm.showDialog()
    },
    // 信箱分组
    alterLetterBox (row) {
      console.log(row)
      this.alterLetterBoxForm.form.id = row.id
      this.alterLetterBoxForm.form.boxId = row.letterBox.id
      this.$refs.alterLetterBoxForm.showDialog()
    },
    // 修改表单分组确定
    handleConfirmAlterLetterForm (data) {
      console.log(data)
      this.alterLetterForm.loading = true
      this.$request.fetchLetterTypeAlter(data).then(res => {
        console.log(res.data)
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchTableApi()
        }
        this.alterLetterForm.loading = false
      })
    },
    // 修改信箱分组确定
    handleConfirmAlterLetterBox (data) {
      console.log(data)
      this.alterLetterBoxForm.loading = true
      this.$request.fetchLetterTypeAlter(data).then(res => {
        console.log(res.data)
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchTableApi()
        }
        this.alterLetterBoxForm.loading = false
      })
    },
    // 头部删除
    handleHeaderDelete () {
      if (this.list.selectedKeys.length > 0) {
        this.$confirm('删除表单连同表单中的数据一起删除，是否确定删除表单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = this.list.selectedKeys
          this.fetchLetterTypeDelete(ids)
        })
      } else {
        this.$message('请选择需要操作的数据')
      }
    },
    // 列表搜索
    handleSearchs () {
      this.fetchTableApi()
    },
    // 表格数据
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content.map(d => {
          // if (d.viewStatus === 0) {
          //   d.hiddenStop = true
          // } else if (d.viewStatus === 1 || d.viewStatus === 2) {
          //   d.hiddenIssue = true
          // }
          // if (d.joinCount === 0) {
          //   d.disabledDerive = true
          //   d.disabledEmpty = true
          // }

          return d
        })
        this.list.totalCount = res.data.totalElements
      }
    },
    // 图标链接跳转
    toLinkAddress (row) {
      this.$routerLink('/interact/letter/type/detail', 'Edit', { link: 'linkAddress', state: row.viewStatus, id: row.id })
    },
    // 标题跳转
    toEdit (row) {
      if (row.viewStatus === 1 || row.viewStatus === 2) {
        this.$confirm('此表单处于进行中状态，编辑表单时表单会暂停发布，将导致正在填写此表单的用户无法提交而必须重新填写，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {}
          data.ids = [row.id]
          data.publish = false
          this.fetchSmartFormPublishPut(data)
          this.$routerLink('/interact/letter/type/detail', 'link', { id: row.id, state: 0 })
        }).catch(() => {})
      } else {
        this.$routerLink('/interact/letter/type/detail', 'link', { id: row.id, state: row.viewStatus })
      }
    },
    // 表格跳统计
    // gotoStatistics (row) {
    //   this.$routerLink('/interact/letter/form/detail', 'link', { link: 'statistical', id: row.id, state: row.viewStatus })
    // },
    // 表格编辑
    handleEdit (data) {
      this.toEdit(data)
    },
    // 表格删除
    handleTableDelete (row) {
      this.$confirm('删除表单连同表单中的数据一起删除，是否确定删除表单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [row.id]
        this.fetchLetterTypeDelete(ids)
      })
    },
    // 表单删除
    fetchLetterTypeDelete (ids) {
      this.$request.fetchLetterTypeDelete({ ids }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchTableApi()
        }
      })
    },
    // 表单列表
    fetchLetterBoxList () {
      let params = {
        name: '',
        boxTypeId: ''
      }
      this.$request.fetchLetterBoxPage(params).then(res => {
        if (res.code === 200) {
          this.formEdit.formItems.find(d => d.prop === 'boxId').options = res.data.content.map(d => {
            d.label = d.name;
            d.value = d.id;
            return d
          })
          this.alterLetterBoxForm.formItems.find(d => d.prop === 'boxId').options = res.data.content.map(d => {
            d.label = d.name;
            d.value = d.id;
            return d
          })
        }
      })
    },
    // 表单列表
    fetchFormList () {
      let params = {
        name: ''
      }
      this.$request.fetchLetterFormPage(params).then(res => {
        if (res.code === 200) {
          this.formEdit.formItems.find(d => d.prop === 'formId').options = res.data.content.map(d => {
            d.label = d.title;
            d.value = d.id;
            return d
          })
          this.alterLetterForm.formItems.find(d => d.prop === 'formId').options = res.data.content.map(d => {
            d.label = d.title;
            d.value = d.id;
            return d
          })
        }
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.fetchFormList()
      this.fetchLetterBoxList()
    })
  },
  activated () {
    this.fetchTableApi()
  }
}
</script>

<style lang="scss">
  .interact-forbid-index-container{
    
  }
</style>